<div data-test="jd9e8P2Z" class="date-switch" UIKitDropdown>
  <button
    data-test="TG62ZPlp"
    (click)="prevMonth()"
    class="date-switch__button date-switch__button-prev button button_secondary"
  >
    <i data-test="TuqcYU5P" class="material-icons md-16">keyboard_arrow_left</i>
  </button>
  <button
    data-test="Dmc6YO-d"
    class="date-switch__text button button_secondary"
    style="width: 90px"
  >
    {{ monthsList[month] }}
  </button>
  <button
    data-test="-DlKTFOQ"
    (click)="nextMonth()"
    class="date-switch__button date-switch__button-next button button_secondary"
  >
    <i data-test="iNKdqixI" class="material-icons md-16">keyboard_arrow_right</i>
  </button>
</div>
